module.exports = __webpack_public_path__ + "assets/a4289573f4c1942250336b8616e37110.png";